type regexString<Pattern extends RegExp> = string & { __regexPattern: Pattern };

// prefix for sorting_links for fullscreen config
export const sortingLinkPrefix = /^sorting_links\/.*/;
export type SortingLinkTypePrefix = regexString<typeof sortingLinkPrefix>;

export enum VehicleTypeEnums {
  ELECTRIC = "ELECTRIC",
  NORMAL = "NORMAL",
}

export enum FullscreenTypeEnums {
  RACK = "RACK",
  TROLLEY = "TROLLEY",
}

// FE surfaces rack as box for fullscreen tracking
export enum FullscreenMapEnums {
  RACK = "BOX",
  TROLLEY = "TROLLEY",
}

export enum FullscreenConfigEnums {
  RACK = "RACK",
  TROLLEY = "TROLLEY",
}

// settings for order processing
export enum OrderSettingsEnum {
  SPECIAL_CARE = "SPECIAL_CARE",
  SPECIAL_CONDITION = "SPECIAL_CONDITION",
  SERVICE_TYPE = "SERVICE_TYPE",
  DELIVERY_TYPE = "DELIVERY_TYPE",
  LOCATION = "LOCATION",
  RATE_TABLE = "RATE_TABLE",
  CUSTOMER_RATE_TABLE = "CUSTOMER_RATE_TABLE",
  ISSUE_TYPE = "ISSUE_TYPE",
  TYPE_OF_GOODS = "TYPE_OF_GOODS",
  INSURANCE = "INSURANCE",
}

export const UploadMassOrderStrings = [
  OrderSettingsEnum.SPECIAL_CARE,
  OrderSettingsEnum.SPECIAL_CONDITION,
  OrderSettingsEnum.SERVICE_TYPE,
  OrderSettingsEnum.DELIVERY_TYPE,
  OrderSettingsEnum.ISSUE_TYPE,
];

// rate table surcharge
export enum SurchargeTypeEnums {
  DEFAULT = "DEFAULT",
  DISCOUNT = "DISCOUNT",
  MARKUP = "MARKUP",
}
